const prefix = 'COUNSELOR_MEETING_SCHEDULER';

export const POPULATE_MEETING_SETTINGS = `${prefix}/POPULATE_MEETING_SETTINGS`;
export const POPULATE_AVAILABILITIES = `${prefix}/POPULATE_AVAILABILITIES`;
export const POPULATE_MEETINGS = `${prefix}/POPULATE_MEETINGS`;
export const POPULATE_ATTENDEE_MEETINGS = `${prefix}/POPULATE_ATTENDEE_MEETINGS`;
export const POPULATE_MEETING_DETAILS = `${prefix}/POPULATE_MEETING_DETAILS`;

export const weekDaysToShow = [
  {
    title: 'Monday',
    number: 1,
  },
  {
    title: 'Tuesday',
    number: 2,
  },
  {
    title: 'Wednesday',
    number: 3,
  },
  {
    title: 'Thursday',
    number: 4,
  },
  {
    title: 'Friday',
    number: 5,
  },
];

export const timeFormat = 'HH:mm:ss';
export const dateFormat = 'YYYY-MM-DD';
// We use static date for reference purpose when user create availability slots
// to avoid issue where slot creator is in or not in DST when they are creating slots
// since slot is not related to date, it's time in a day instead.
// this is used for viewing/creating availability slots
export const timeStampReferenceDate = '1970-08-01';

export const tooltipDateFormat = 'dddd, MMMM Do';
export const tooltipTimeFormat = 'h:mma';
